export const Storage = {
  PUBLIC_SITEMAP: 'JB!X_SM',
  AUTH_URL: 'JB!auth-url',
  ENGLISH_CULTURE: 'en-US',
  AUTH_TOKEN: 'JB!auth-token',
  DATASTORE: 'JB!datastore', // This needs to be removed and use file handler instead.
  REALM: 'JB!realm',
  TRANSLATIONS_HASH: 'translationsHash',
  ELIXHRUI_URL: 'elixHRUIUrl',
  CULTURE: 'selectedCulture',
  RESUME_ACTIONS: 'resume_actions',
  LOGIN_URL: 'JB!login-url',
  RESET_PASSWORD_URL: 'JB!reset-password-url',
  HOME_REDIRECT_URL: 'JB!home-redirect-url',
  LOGO_REDIRECT_URL: 'JB!logo-redirect-url',
  VIEW_MATCH_PERCENT: 'JB!view-match-percent',
  ENABLE_JOB_ALERT: 'JB!enable-job-alert'
};

export const RouteName = {
  SIGNIN: 'signin',
  JOB_SEARCH: 'jobsearch',
  SEARCH: 'search',
  UPLOAD_RESUME: 'uploadresume',
  TIMELINE: 'timeline',
  JOB_ALERT: 'jobalert',
  CANDIDATE: 'candidate',
  JOB: 'job',
  AUTH: 'auth',
  RESET: 'reset',
  JOB_FILTERS: 'jobfilters',
  SITEMAP: 'sitemap',
  EDIT_PROFILE: 'editprofile',
  EDIT_RESUME: 'editresume',
  RESUME_LIBRARY: 'library',
  ASSESSMENT: 'assessment',
  CANDIDATE_ASSESSMENT: 'candidateassessment',
  INTERVIEW_DETAILS: 'interviewdetails',
  JOB_VIEW: 'view',
  ERROR_PAGE: 'error',
  TIMELINE_CANDIDATE_ASSESSMENT: 'candidateassessment',
  DOCUMENT_UPLOAD: 'documents',
  OFFER_PREVIEW: 'offerpreview',
};

export const CareerHomeRoute = '/Careers/';
export const CareersString = 'careers'
export const ENABLE_LINKEDIN_V3 = 'in.awli.v3.enabled';



// WEBPACK FOOTER //
// ../UI/src/app/shared/constants.ts